import { createSelector } from 'reselect';
import { isEditable } from '../utils';

export const customGroupsSelector = state => state.administration.customGroups.customGroups;
export const selectedCustomGroupIdSelector = state =>
  state.administration.customGroups.selectedCustomGroupId;

export const selectedCustomGroupSelector = createSelector(
  [customGroupsSelector, selectedCustomGroupIdSelector],
  (customGroups, selectedCustomGroupId) => customGroups.find(item => item.id === selectedCustomGroupId)
);

export const isSelectedCustomGroupEditableSelector = createSelector(
  [
    state => state.user.user.sso,
    customGroupsSelector,
    selectedCustomGroupIdSelector,
  ],
  (sso, customGroups, selectedCustomGroupId) => {
    const selectedCustomGroup = customGroups.find(group => group.id === selectedCustomGroupId);
    return isEditable(sso, selectedCustomGroup);
  }
);

export const selectedCustomGroupItemTypeSelector = createSelector(
  [
    state => state.administration.customGroups.customGroupItemTypes,
    state => state.administration.customGroups.selectedCustomGroupItemType,
  ],
  (customGroupItemTypes, selectedCustomGroupItemType) => {
    const foundType = [
      ...customGroupItemTypes.CG,
      ...customGroupItemTypes.BR,
    ].find(type => type.value === selectedCustomGroupItemType);
    return foundType ? foundType.value : null;
  }
);

const getCustomGroupItems = (customGroupItems, selectedCustomGroupItemType) =>
  customGroupItems?.filter(item => selectedCustomGroupItemType
    ? item.itemType === selectedCustomGroupItemType
    : true
  )
    .map(item => ({
      value: item.itemName,
      label: item.itemLabel,
      type: item.itemType,
    })) ?? [];

export const customGroupItemsSelector = createSelector(
  [
    state => state.administration.customGroups.customGroupItems,
    state => state.administration.customGroups.selectedCustomGroupItemType,
  ],
  (customGroupItems, selectedCustomGroupItemType) => ({
    CG: customGroupItems?.CG ? getCustomGroupItems(customGroupItems.CG, selectedCustomGroupItemType) : [],
    BR: customGroupItems?.BR ? getCustomGroupItems(customGroupItems.BR, selectedCustomGroupItemType) : [],
  })
);

export const customGroupItemTypesSelector = createSelector(
  [
    state => state.administration.customGroups.customGroupItemTypes,
  ],
  customGroupItemTypes => ({
    CG: customGroupItemTypes?.CG?.map(type => ({ value: type.value, label: type.name })) ?? [],
    BR: customGroupItemTypes?.BR?.map(type => ({ value: type.value, label: type.name })) ?? [],
  })
);

export const readOnlySelector = state => state.administration.customGroups.readOnly;

export const isCreatingNewCustomGroupSelector = state =>
  state.administration.customGroups.isCreatingNewCustomGroup;

export const isCustomGroupModifiedSelector = state => state.administration.customGroups.isCustomGroupModified;

export const isDeletingCustomGroupInProgressSelector = ({ administration }) =>
  administration.customGroups.isDeletingCustomGroupInProgress;

export const isRefreshingCustomGroupsSelector = state => state.administration.customGroups.isRefreshingCustomGroups;

export const isArchiveAdminSelector = state => state.administration.customGroups.isArchiveAdmin;
